import type { AjaxError } from 'rxjs';
import { post } from 'epics/ajax';
import { isUiModificationsForgeContextTokenEndpointEnabled } from 'feature-flags';
import {
    ContextTokenType,
    type ContextTokenData,
    type Extension,
    type ExtensionData,
} from '@atlassian/help-center-common-component/forge-ui/types';
import { trackError } from '@atlassian/help-center-common-util/analytics';
import { contextPath } from '@atlassian/help-center-common-util/history';
import type { FCTRequest, FetchForgeContextTokenAjaxResponse } from './types';
import { getForgeContextTokenEndpoint, type ENDPOINT_MAP } from './utils';

export const fetchForgeContextToken = ({
    extension,
    extensionData,
    context = contextPath,
    contextTokenType = ContextTokenType.JSM,
}: {
    extension: Extension;
    extensionData: ExtensionData;
    context?: string;
    contextTokenType?: keyof typeof ENDPOINT_MAP;
}): Promise<ContextTokenData> => {
    const uri = isUiModificationsForgeContextTokenEndpointEnabled()
        ? `${context}${getForgeContextTokenEndpoint(contextTokenType)}`
        : `${context}/rest/servicedesk/1/customer/servicedesk-data/forge/context-token`;
    const body: FCTRequest = {
        extension,
        extensionData,
    };

    const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
    };

    return post(uri, body, headers)
        .map(({ response }: FetchForgeContextTokenAjaxResponse) => response)
        .catch((e: AjaxError) => {
            trackError('forge-context-token.fetch.failed', {}, e);
            return Promise.reject(e);
        })
        .toPromise();
};
